import { render, staticRenderFns } from "./DeviceForm.vue?vue&type=template&id=23107e89&scoped=true&"
import script from "./DeviceForm.vue?vue&type=script&lang=ts&"
export * from "./DeviceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23107e89",
  null
  
)

export default component.exports